import { Eye, EyeSlash } from "@phosphor-icons/react";
import type React from "react";
import { useState } from "react";
import type { Except } from "type-fest";

import { Input } from "./Input";

export const PasswordInput: React.FC<
  Except<React.ComponentProps<"input">, "type">
> = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <div className="relative grid">
      <Input {...props} type={isVisible ? "text" : "password"} />
      <div className="absolute right-2 top-2">
        <div
          className="tooltip tooltip-left"
          data-tip={`${isVisible ? "Hide" : "Show"} password`}
        >
          <button
            type="button"
            className="btn btn-square btn-sm"
            onClick={() => {
              setIsVisible((prev) => !prev);
            }}
          >
            {isVisible ? (
              <EyeSlash weight="bold" className="size-5" />
            ) : (
              <Eye weight="bold" className="size-5" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
